import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NavbarComponent } from './navbar/navbar.component';
import { SliderComponent } from './slider/slider.component';
import { AboutComponent } from './about/about.component';
import { MovieSliderComponent } from './movie-slider/movie-slider.component';
import { BoxOfficeComponent } from './box-office/box-office.component';
import { CurrencyPipe } from './pipe/currency.pipe';
import { SubscribeComponent } from './subscribe/subscribe.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomFormsModule } from 'ng2-validation';
import { LatestNewsComponent } from './latest-news/latest-news.component';
import { PharaPipe } from './pipe/phara.pipe';
import { DatePipe } from './pipe/date.pipe';
import { MovieImagesShowComponent } from './movie-images-show/movie-images-show.component';
import { LatsetTailerrComponent } from './latset-tailerr/latset-tailerr.component';
import { HomeComponent } from './final-component/home/home.component';
import { ShowTailerComponent } from './show-tailer/show-tailer.component';
import { SafePipe } from './pipe/safe.pipe';
import { FooterComponent } from './footer/footer.component';
import { MovieTypePipe } from './pipe/movie-type.pipe';
import { LoginPageComponent } from './final-component/login-page/login-page.component';
import { CheckBlurValueDirective } from './directives/check-blur-value.directive';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ContactComponent } from './final-component/contact/contact.component';
import { AllNewsComponent } from './all-news/all-news.component';
import { NewsComponent } from './final-component/news/news.component';
import { NewsDetailsComponent } from './news-details/news-details.component';
import { HotTopicComponent } from './hot-topic/hot-topic.component';
import { TweetsComponent } from './tweets/tweets.component';
import { SpecificTagComponent } from './specific-tag/specific-tag.component';
import { TagsComponent } from './tags/tags.component';
import { SpecificWritterComponent } from './specific-writter/specific-writter.component';
import { SearchComponent } from './search/search.component';
import { SearchSiteComponent } from './search-site/search-site.component';
import { MovieComponent } from './final-component/movie/movie.component';
import { TypeMovieComponent } from './type-movie/type-movie.component';
import { GenresComponent } from './genres/genres.component';
import { MovieDetailsComponent } from './movie-details/movie-details.component';
import { ScheduleComponent } from './final-component/schedule/schedule.component';
import { UserNavbarComponent } from './user-navbar/user-navbar.component';




@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    SliderComponent,
    AboutComponent,
    MovieSliderComponent,
    BoxOfficeComponent,
    CurrencyPipe,
    SubscribeComponent,
    LatestNewsComponent,
    PharaPipe,
    DatePipe,
    MovieImagesShowComponent,
    LatsetTailerrComponent,
    HomeComponent,
    ShowTailerComponent,
    SafePipe,
    FooterComponent,
    MovieTypePipe,
    LoginPageComponent,
    CheckBlurValueDirective,
    LoginComponent,
    RegisterComponent,
    ChangePasswordComponent,
    ContactComponent,
    AllNewsComponent,
    NewsComponent,
    NewsDetailsComponent,
    HotTopicComponent,
    TweetsComponent,
    SpecificTagComponent,
    TagsComponent,
    SpecificWritterComponent,
    SearchComponent,
    SearchSiteComponent,
    MovieComponent,
    TypeMovieComponent,
    GenresComponent,
    MovieDetailsComponent,
    ScheduleComponent,
    UserNavbarComponent 
   
  ],
  imports: [
    BrowserModule,
    AppRoutingModule , 
    FormsModule,                               
    ReactiveFormsModule  , 
    CustomFormsModule


    
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
